(ns nl.mediquest.be-my-coach-frontend.views.filters
  (:require
   [nl.mediquest.be-my-coach-frontend.config :as config]
   [nl.mediquest.be-my-coach-frontend.events :as events]
   [nl.mediquest.be-my-coach-frontend.subs :as subs]
   [nl.mediquest.be-my-coach-frontend.util
    :refer [separate-scroll-context]]
   [nl.mediquest.be-my-coach-frontend.views.react-helpers
    :refer [focus-on-mount]]
   [re-frame.core :as re-frame]))

(defn- blur-in-ancestory?
  [^js ev]
  (.contains
   (.-currentTarget ev)
   (.-relatedTarget ev)))

(defn- related-target-has-target-as-for-attribute?
  "Check whether the related target has a for attribute that id's the target of this event.
   See: [relatedTarget](https://developer.mozilla.org/en-US/docs/Web/API/FocusEvent/relatedTarget)"
  [^js ev]
  (try
    (=
     (.. ev -target -id)
     (.. ev -relatedTarget -attributes -for -value))
    (catch js/Error _ false)))

(def ^:private standard-button-classes
  ["cursor-pointer" "text-white" "text-center" "bg-bmc-secondary" "px-4" "py-2"
   "rounded-md" "hover:bg-bmc-primary" "disabled:cursor-not-allowed"
   "disabled:bg-gray-300"])

(defn- submit-button
  []
  [:button
   {:type :submit
    :class (into ["w-full"] standard-button-classes)
    :on-click #(re-frame/dispatch [::events/filter-zorgverleners])}
   "Pas toe"])

(defn- filter-option-checkbox
  [k id]
  [:label.cursor-pointer.flex.flex-row
   [:input.mx-2.cursor-pointer.peer.hidden
    {:type :checkbox
     :value id
     :checked @(re-frame/subscribe [::subs/checked? k id])
     :on-change #(re-frame/dispatch [::events/toggle-options k id])}]
   [:span.mr-1.text-bmc-primary.absolute.opacity-0.peer-checked:opacity-100.transition
    [:i.fa.fa-square-check]]
   [:span.mr-1.text-bmc-primary.opacity-100.peer-checked:opacity-0.transition
    [:i.fa-regular.fa-square]]
   [:span (get-in config/locale [:nl id] id)]])

(defn- filter-section-checkboxes
  [k {:keys [options] :as _filter-category}]
  [:div.flex.flex-col.py-2.space-y-2
   (doall
    (for [id options]
      ^{:key (str id)}
      [filter-option-checkbox k id]))])

(defn- filter-section
  [[k {:keys [title] :as filter-category}]]
  ^{:key (str k)}
  [:div
   [:div.flex.items-center
    [:div.text-md.font-bold title]]
   [filter-section-checkboxes k filter-category]])

(defn- filters
  []
  (when-let [filter-categories @(re-frame/subscribe [::subs/filters])]
    [:<>
     (doall
      (for [filter-category filter-categories]
        ^{:key (key filter-category)}
        [filter-section filter-category]))]))

(defn- close-on-blur
  [^js event]
  ;; NOTE - Don't react to the blur event when:
  ;; * The focussed element is a descendent of this element,
  ;;   because the user is still doing stuff in the filter panel.
  ;;
  ;; * The panel opening button is clicked. If the blur closes the
  ;;   panel now, the click event will immediately open it again.
  ;;   Instead, we ignore this event so the click event can decide how
  ;;   to deal with it.
  (when-not (or (blur-in-ancestory? event)
                (related-target-has-target-as-for-attribute? event))
    (re-frame/dispatch [::events/filter-panel false])))

(defn filter-panel
  []
  [separate-scroll-context
   [:div.p-4.space-y-6
    [:p.text-xl.font-bold
     "Filter opties"]
    [filters]
    [:button.text-bmc-primary.hover:cursor-pointer
     {:on-click #(re-frame/dispatch [::events/clear-filters])}
     [:i.fa.fa-square-xmark.pr-1]
     "Verwijder alle filters"]
    [submit-button]]])

(defn view
  []
  (let [open? (re-frame/subscribe [::subs/filter-panel-open?])]
    [:div.py-4.transition-width.transition-padding.ease-in-out.overflow-scroll
     {:class (if @open? ["w-1/3" "px-4"] ["w-0"])}
     (when @open?
       [:f> focus-on-mount
        [:div#filter-panel
         {:tab-index "-1"
          :on-blur close-on-blur}
         [filter-panel]]])]))

(defn postal-code-input
  []
  [:form.relative.my-5.mr-8
   {:method :dialog
    :class ["group/postcode-input"]
    :on-submit #(re-frame/dispatch [::events/filter-zorgverleners])}
   [:button.absolute.right-0
    {:type :submit}
    [:div.absolute.w-8.h-8.mt-1.mr-1.p-1.bg-bmc-primary.rounded-full.opacity-50
     {:class ["group-hover/postcode-input:animate-ping"]}]
    [:div.overflow-hidden.w-8.h-8.mt-1.mr-1.text-2xl.text-white.p-1.bg-bmc-primary.rounded-full
     [:i.fa.fa-search
      {:class ["translate-x-[2px]" "translate-y-[-1px]"]}]]]
   [:input.py-2.px-4.bg-white.rounded-full.invalid:outline.invalid:outline-red-600
    {:placeholder "Eigen postcode"
     :type :text
     :title "Vul je eigen postcode in om te sorteren op afstand, zoals 3811BH"
     :pattern "^[0-9]{4} *([A-Za-z]{2})?$"
     :on-change #(re-frame/dispatch [::events/submit-postcode (.. % -target -value)])}]])
